<template>
	<v-menu
		ref="scheduleMenu"
		:close-on-content-click="false"
		v-model="toggleMenu"
		:nudge-right="40"
		transition="scale-transition"
		offset-y>
		<v-text-field
			slot="activator"
			v-model="scheduleDateTime"
			:label="textLabel"
			:prepend-inner-icon="prependInnerIcon"
			:prepend-icon="prependIcon"
			readonly>						
		</v-text-field>
		<v-date-picker v-model="scheduleDate" @input="updateValue" no-title scrollable>
			<v-flex column>
				<v-select :items="timeOptions" v-model="scheduleTime" @input="updateValue" solo></v-select>
				<div class="text-xs-right">
					<v-spacer></v-spacer>
					<v-btn flat color="primary" @click="handleClose">Ok</v-btn>
				</div>
			</v-flex>
		</v-date-picker>
	</v-menu>
</template>

<script>
	export default {
		props: {
			value: {
				type: String,
				default: ''
			},
			textLabel: {
				type: String,
				default: 'Publish on'
			},
			prependInnerIcon: {
				type: String,
				default: "event"
			},
			prependIcon: {
				type: String,
				defaut: ''
			},
			allowNull: {
				type: Boolean,
				default: false
			}
		},
		data () {
			return {
				scheduleDateTime: null,
				scheduleDate: null,
				scheduleTime: null,
				timeOptions: [],
				toggleMenu: false
			}
		},
		mounted () {
			var i, hourString

			for (i=0;i<=23;i++) {
				hourString = '0' + i.toString()
				hourString = hourString.substring(hourString.length - 2, hourString.length)

				this.timeOptions.push(hourString + ':00:00')
			}

			if (this.value === 'undefined') {
				if (this.allowNull) {
					this.scheduleDate = new Date().toISOString().split('T')[0]
					this.scheduleTime = '00:00:00'
				} else {
					this.scheduleDate = ''
					this.scheduleTime = ''
				}
			} else if (!this.value) {
				if (this.allowNull) {
					this.scheduleDate = new Date().toISOString().split('T')[0]
					this.scheduleTime = '00:00:00'
				} else {
					this.scheduleDate = ''
					this.scheduleTime = ''
				}
			} else {
				this.scheduleDate = this.value.split(' ')[0]
				this.scheduleTime = this.value.split(' ')[1]
			}
			if (this.allowNull) {
				this.scheduleDateTime = ''
			} else {
				this.scheduleDateTime = this.scheduleDate + ' ' + this.scheduleTime
			}
		},
		methods: {
			updateValue () {
				this.scheduleDateTime = this.scheduleDate + ' ' + this.scheduleTime
				this.$emit('input', this.scheduleDateTime.trim())
			},
			handleClose () {
				this.$emit('input', this.scheduleDateTime.trim())
		 		this.toggleMenu = false
			}
		},
		watch: {
			value (props) {
				this.scheduleDateTime = props
				this.scheduleDate = props.split(' ')[0]
				this.scheduleTime = props.split(' ')[1]
			}
		}
	}
</script>

<style lang="scss">
	
</style>